import React from 'react';
import { useParams } from 'react-router-dom';
import { ConversionForm } from './ConversionForm';
import { ToolsPanel } from './ToolsPanel';
import { UnitComparison } from './UnitComparison';
import { SmartCalculator } from './SmartCalculator';
import { AdvancedTools } from './AdvancedTools';
import { UnitCategory } from '../types/units';
import { AIMLTools } from './AIMLTools';

export function MainContent() {
  const { category = 'length' } = useParams<{ category: string }>();

  return (
    <>
      <ConversionForm category={category as UnitCategory} />
      <ToolsPanel category={category as UnitCategory} />
      <UnitComparison category={category as UnitCategory} />
      <SmartCalculator category={category as UnitCategory} />
      <AdvancedTools category={category as UnitCategory} />
      {category === 'ai-ml' && <AIMLTools category={category} />}
    </>
  );
} 